// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3ZKoR","title":"style_title__1I-1M","description":"style_description__3Cle9","button":"style_button__1w06v"};